
import type { PropType, SetupContext } from 'vue'
import type { LinkedListItem } from '../../models'

import { defineComponent, ref, watch } from 'vue'

import { AlignEnum } from '../../enums'

import FadingScroll from '../fading-scroll.component.vue'

import ItemLinkedList from './item-linked-list.component.vue'

export default defineComponent({
  name: 'LinkedList',
  components: {
    FadingScroll,
    ItemLinkedList,
  },
  props: {
    items: {
      type: Array as PropType<Array<LinkedListItem>>,
      required: true,
    },
    collapsed: Boolean,
  },
  setup(
    props: {
      items: Array<LinkedListItem>
      collapsed: boolean
    },
    ctx: SetupContext,
  ) {
    const { emit } = ctx

    const baseClass = 'epb-linked-list'
    const resizeDirection = ref(AlignEnum.START)
    const fadingScrollRef = ref()

    const onUpdateResizeDirection = (direction: AlignEnum): void => {
      resizeDirection.value = direction
    }

    const onItemClick = (item: LinkedListItem): void => {
      resizeDirection.value = AlignEnum.START
      emit('onClick', item)
    }

    watch(
      (): boolean => props.collapsed,
      (): void => {
        resizeDirection.value = AlignEnum.START
        if (fadingScrollRef.value) {
          fadingScrollRef.value.scrollTo({ left: 0 })
        }
      },
      { deep: true },
    )

    return {
      baseClass,
      fadingScrollRef,
      resizeDirection,
      onUpdateResizeDirection,
      onItemClick,
      emit,
    }
  },
})
